import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLazyLoad } from '@/vdp/Device/actions';
import Sections from '~/constants/sections';
import useSelector from '~/store/useSelector';
import { SET_HASH } from '../actionTypes';

const usePageHash = () => {
  const dispatch = useDispatch();
  const hash = useSelector(state => state.router.hash);

  useEffect(() => {
    const setPageHash = () => {
      dispatch({
        type: SET_HASH,
        payload: window.location.hash.substring(1)
      });
    };

    setPageHash();

    window.addEventListener('hashchange', setPageHash, false);

    return () => {
      window.removeEventListener('hashchange', setPageHash, false);
    };
  }, [dispatch]);

  useEffect(() => {
    switch (hash) {
      case Sections.Inspection150Point:
      case Sections.KeyFeatures:
      case Sections.OwnerReviews:
      case Sections.PriceDetails:
      case Sections.VehicleDetails: {
        dispatch(setLazyLoad(false));
        break;
      }
      case Sections.Root: {
        // Remove #root from the URL
        window.history.replaceState(
          '',
          document.title,
          window.location.pathname + window.location.search
        );
        break;
      }
      default:
    }
  }, [dispatch, hash]);
};

export default usePageHash;
